/* Options:
Date: 2026-10-01 15:13:36
Version: 8.10
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

// @ts-nocheck

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IGet
{
}

export interface IPost
{
}

export enum OpenSpecimenSynchronisationType
{
    Institutes = 1,
    Sites = 2,
    Users = 3,
    SiteCoordinators = 4,
    CollectionProtocols = 5,
    CollectionProtocolCoordinators = 6,
    FormContexts = 7,
    CollectionProtocolFormContexts = 8,
    FormDefinitions = 9,
    Forms = 10,
    CollectionProtocolEvents = 11,
    CollectionProtocolGroups = 12,
    CollectionProtocolGroupCollectionProtocols = 13,
    CollectionProtocolRegistrations = 14,
    Participants = 15,
    DistributionProtocols = 16,
    DistributionProtocolCoordinators = 17,
    DistributionProtocolSpecimens = 18,
    DistributionOrders = 19,
    DistributionOrderItems = 20,
    SpecimenTypes = 21,
    SpecimenRequirements = 22,
    Visits = 23,
    AnticipatedVisits = 24,
    StorageLocations = 25,
    StorageContainers = 26,
    StorageContainerChildren = 27,
    StorageContainerNames = 28,
    StorageContainerTypes = 29,
    Specimens = 30,
    AnticipatedSpecimens = 31,
    SpecimenKits = 32,
    SpecimenKitSpecimens = 33,
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Biobank
{
    // @DataMember
    public collectionProtocolId?: number;

    // @DataMember
    public trialManagementId?: number;

    // @DataMember
    public enabled?: boolean;

    // @DataMember
    public code: string;

    // @DataMember
    public snapshot: string;

    // @DataMember
    public totalParticipantSamples?: number;

    // @DataMember
    public totalParticipantsBCT?: number;

    // @DataMember
    public totalParticipantsNonBCT?: number;

    // @DataMember
    public numberParticipantsProvidingSamples?: number;

    // @DataMember
    public participantsInControlArm: string;

    // @DataMember
    public participantsInTestArms: string;

    // @DataMember
    public preTxPostTxBlocks: string;

    // @DataMember
    public totalSamples?: number;

    // @DataMember
    public data: { [index:string]: number; };

    // @DataMember
    public neoAdj: string;

    // @DataMember
    public metatastic: string;

    // @DataMember
    public tnbc: string;

    // @DataMember
    public erprPositive: string;

    // @DataMember
    public heR2Positive: string;

    // @DataMember
    public erprNegative: string;

    // @DataMember
    public heR2Negative: string;

    // @DataMember
    public stage: string;

    // @DataMember
    public other: string;

    // @DataMember
    public sampleOrigin?: number;

    public constructor(init?: Partial<Biobank>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    public dsn: string;
    public environment: string;
    public customer: string;
    public sendDefaultPii: boolean;
    public enableMetrics: boolean;
    public attachStacktrace: boolean;
    public debug: boolean;
    public enableLogs: boolean;
    public enableReportABug: boolean;
    public replaysOnErrorSampleRate: number;
    public replaysSessionSampleRate: number;
    public tracesSampleRate: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    public sentry: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export enum SqlReportColumnType
{
    String = 1,
    Number = 2,
    Date = 3,
    DateTime = 4,
}

export class SqlReportColumn
{
    public header: string;
    public type?: SqlReportColumnType;
    public sortable?: boolean;
    public filterable?: boolean;
    public filterableDropDown?: boolean;
    public minimumWidth?: number;
    public maximumWidth?: number;

    public constructor(init?: Partial<SqlReportColumn>) { (Object as any).assign(this, init); }
}

export class SqlReport
{
    public title: string;
    public description: string;
    public data: { [index:string]: Object; }[];
    public columns: { [index:string]: SqlReportColumn; };
    public idColumnName: string;
    public hasPermission?: boolean;

    public constructor(init?: Partial<SqlReport>) { (Object as any).assign(this, init); }
}

export enum UserType
{
    Contact = 1,
    Super = 2,
    Institute = 3,
    None = 4,
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    public responseStatus: ResponseStatus;
    public settings: ClientAppSettings;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class PostSynchroniseOpenSpecimenResponse
{
    public responseStatus: ResponseStatus;
    public count?: number;

    public constructor(init?: Partial<PostSynchroniseOpenSpecimenResponse>) { (Object as any).assign(this, init); }
}

export class PostCleanOpenSpecimenSynchronisationCacheResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostCleanOpenSpecimenSynchronisationCacheResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetBiobankDatResponse
{
    // @DataMember
    public responseStatus: ResponseStatus;

    // @DataMember
    public biobankData: Biobank[] = [];

    // @DataMember
    public classifications: string[] = [];

    public constructor(init?: Partial<GetBiobankDatResponse>) { (Object as any).assign(this, init); }
}

export class PostQuerySqlReportResponse
{
    public report: SqlReport;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostQuerySqlReportResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    public responseStatus: ResponseStatus;
    public userId: string;
    public sessionId: string;
    public userName: string;
    public displayName: string;
    public permissions: string[];
    public type?: UserType;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @Route("/client-app-settings")
export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>, IGet
{

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @Route("/CheckLogin")
export class CheckLogin
{

    public constructor(init?: Partial<CheckLogin>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CheckLogin'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/TestOrm")
export class TestOrmLite
{

    public constructor(init?: Partial<TestOrmLite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TestOrmLite'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class PostSynchroniseOpenSpecimen implements IReturn<PostSynchroniseOpenSpecimenResponse>
{
    public type?: OpenSpecimenSynchronisationType;
    public guid: string;

    public constructor(init?: Partial<PostSynchroniseOpenSpecimen>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSynchroniseOpenSpecimen'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSynchroniseOpenSpecimenResponse(); }
}

export class PostCleanOpenSpecimenSynchronisationCache implements IReturn<PostCleanOpenSpecimenSynchronisationCacheResponse>
{
    public guid: string;

    public constructor(init?: Partial<PostCleanOpenSpecimenSynchronisationCache>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCleanOpenSpecimenSynchronisationCache'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCleanOpenSpecimenSynchronisationCacheResponse(); }
}

export class GetBiobankData implements IReturn<GetBiobankDatResponse>, IGet
{

    public constructor(init?: Partial<GetBiobankData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBiobankData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBiobankDatResponse(); }
}

export class PostQuerySqlReport implements IReturn<PostQuerySqlReportResponse>
{
    public reportCode: string;

    public constructor(init?: Partial<PostQuerySqlReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostQuerySqlReport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostQuerySqlReportResponse(); }
}

// @Route("/opms/user")
export class GetUser implements IReturn<GetUserResponse>, IGet
{

    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

// @DataContract
export class UpdateBiobankTrialTable
{
    // @DataMember
    public responseStatus: ResponseStatus;

    // @DataMember
    public biobankData: Biobank[] = [];

    public constructor(init?: Partial<UpdateBiobankTrialTable>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBiobankTrialTable'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @DataContract
export class TrialMapping
{
    // @DataMember
    public trialManagementId: number;

    // @DataMember
    public collectionProtocolId: number;

    public constructor(init?: Partial<TrialMapping>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialMappingChoice
{
    // @DataMember
    public id: number;

    // @DataMember
    public name: string;

    // @DataMember
    public missingFromSource: boolean;

    public constructor(init?: Partial<TrialMappingChoice>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialMappingsResponse
{
    // @DataMember
    public mappings: TrialMapping[] = [];

    // @DataMember
    public trials: TrialMappingChoice[] = [];

    // @DataMember
    public collectionProtocols: TrialMappingChoice[] = [];

    // @DataMember
    public revision: string;

    // @DataMember
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialMappingsResponse>) { (Object as any).assign(this, init); }
}

// @Route("/settings/TrialMappings", "GET")
export class GetTrialMappings implements IReturn<GetTrialMappingsResponse>, IGet
{

    public constructor(init?: Partial<GetTrialMappings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialMappings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialMappingsResponse(); }
}

// @Route("/settings/update-trial-mappings", "POST")
// @DataContract
export class UpdateTrialMappings implements IReturn<GetTrialMappingsResponse>, IPost
{
    // @DataMember
    public mappings: TrialMapping[];

    // @DataMember
    public revision: string;

    public constructor(init?: Partial<UpdateTrialMappings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateTrialMappings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetTrialMappingsResponse(); }
}
